const REFRESH_BUFFER_MS = 60_000;

export const createSupabaseTokenProvider = ({
  isAuthenticated,
  isLoading,
  getIdTokenClaims,
  getAccessTokenSilently,
}) => {
  return async () => {
    if (isLoading || !isAuthenticated) return null;

    let claims = await getIdTokenClaims();
    const expiresSoon =
      !claims?.__raw ||
      typeof claims.exp !== 'number' ||
      claims.exp * 1000 <= Date.now() + REFRESH_BUFFER_MS;

    if (expiresSoon) {
      await getAccessTokenSilently();
      claims = await getIdTokenClaims();
    }

    if (!claims?.__raw) {
      throw new Error('Missing Auth0 ID token for Supabase');
    }

    return claims.__raw;
  };
};
